/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {AdServerConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class TcfService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  checkTcf(gdpr: any, consentString?: any): any {
    const params: any = {};
    if (gdpr === 'GDPR_ON') {
      params.gdpr = 1;
    } else if (gdpr === 'GDPR_OFF') {
      params.gdpr = 0;
    } else if (gdpr !== 'GDPR_AD_UNIT') {
      params.auId = gdpr;
    }
    if (consentString) {
      params.consentString = consentString;
    }
    const uri = AdServerConfig.obtain().getUri('consent');
    return this.send({method: 'GET', url: uri, params}).then(function(text: any) {

      if (text.indexOf('TCF Consent') > -1) {
        try {
          const countryMatch = text.match(/Country:\s*([A-Z]{2})/);
          const countryCode = countryMatch ? countryMatch[1] : null;

          const lines = text.split('\n');
          const purposeNumbers: string[] = [];

          lines.forEach((line: string) => {
            if (line.includes('TCF_PURPOSE_')) {
              const number = line.split('TCF_PURPOSE_')[1];
              if (number) {
                purposeNumbers.push(number.trim());
              }
            }
          });

          const gdprValueMatch = text.match(/GDPR:\s*(true|false)/);
          const gdprValue = gdprValueMatch ? gdprValueMatch[1] : null;

          const ipMatch = text.match(/IP:\s*(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/);
          const ipAddress = ipMatch ? ipMatch[1] : null;
          return {
            country: countryCode,
            gdpr: gdprValue,
            tcfPurposes: purposeNumbers,
            tcfPurposesString: purposeNumbers.join(', '),
            ipAddress: ipAddress
          };
        } catch (e) {
          return text;
        }
      }
      return text;
    }).catch(function(error: any) {
      return _.get(error.data, ['message']) || error.data;
    });
  }
}
